import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Box } from '@mantine/core';
import { HamburgerMenu } from './partials/HamburgerMenu';
import { LanguageSelect } from './partials/LanguageSelect';
import { useAuth } from '@/providers/AuthProvider';
import LogoSrc from '@/assets/images/logo.webp';
import styles from './Navbar.module.scss';

const baseSlug = 'navbar.';

export const Navbar: React.FC = () => {
	const { user } = useAuth();

	return (
		<Box
			component="nav"
			id="navbar"
			className={styles.navbar}
			px={{ base: 'md', md: 'lg' }}
		>
			<Box miw={125}>
				<Link to="/">
					<img src={LogoSrc} width={125} />
				</Link>
			</Box>
			<Flex
				display={{
					base: 'none',
					md: 'flex',
				}}
				justify="flex-end"
				className="flex-grow-1"
				gap="lg"
			>
				<LanguageSelect />
			</Flex>
			{!!user && <HamburgerMenu baseSlug={baseSlug} />}
		</Box>
	);
};
